module.exports = __webpack_public_path__ + "img/viz-highlight.173fb634.svg";